import { ConfirmDialog } from "@packages/core-client/forms/ConfirmDialog.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../../i18n/i18next.ts";

export interface DeactivatePersonDialogProps {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    onConfirm: () => void;
    isDeactivating: boolean;
}

export function DeactivatePersonDialog({ isOpen, onOpenChange, onConfirm, isDeactivating }: DeactivatePersonDialogProps) {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("DeactivatePersonDialog", { i18n: i18nextInstance });

    const handleCancel = useCallback(() => onOpenChange(false), [onOpenChange]);

    return <ConfirmDialog isOpen={isOpen} title={t("title")} description={t("body")} confirmLabel={t("confirm")} cancelLabel={t("cancel")} confirmIntent="danger" isConfirming={isDeactivating} onConfirm={onConfirm} onCancel={handleCancel} confirmName="deactivate-person" />;
}
